import { useCallback, useEffect, useState } from 'react';

// Extend the Window interface to include gtag
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, any>
    ) => void;
  }
}

export const useGoogleAnalytics = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Check if gtag is available
    const checkGtag = () => {
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        setIsLoaded(true);
      } else {
        // Retry after a short delay
        setTimeout(checkGtag, 100);
      }
    };

    checkGtag();
  }, []);

  const trackPageView = useCallback((path: string, title: string) => {
    // Check if gtag is available (Google Analytics is loaded)
    if (isLoaded && typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_title: title,
      });
    }
  }, [isLoaded]);

  const trackEvent = useCallback((
    eventName: string,
    parameters?: Record<string, any>
  ) => {
    if (isLoaded && typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters);
    }
  }, [isLoaded]);

  return {
    trackPageView,
    trackEvent,
    isLoaded,
  };
};